module.exports = __webpack_public_path__ + "assets/img/A5-2.5fb0ce04.jpg";